/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LoginImport } from './routes/login'
import { Route as ProtectedImport } from './routes/_protected'
import { Route as IndexImport } from './routes/index'
import { Route as ProtectedDashboardRouteImport } from './routes/_protected/dashboard/route'
import { Route as ProtectedDashboardIndexImport } from './routes/_protected/dashboard/index'
import { Route as ProtectedDashboardUsersRouteImport } from './routes/_protected/dashboard/users/route'
import { Route as ProtectedDashboardMatchsRouteImport } from './routes/_protected/dashboard/matchs/route'

// Create/Update Routes

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedRoute = ProtectedImport.update({
  id: '/_protected',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedDashboardRouteRoute = ProtectedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ProtectedRoute,
} as any)

const ProtectedDashboardIndexRoute = ProtectedDashboardIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedDashboardRouteRoute,
} as any)

const ProtectedDashboardUsersRouteRoute =
  ProtectedDashboardUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => ProtectedDashboardRouteRoute,
  } as any)

const ProtectedDashboardMatchsRouteRoute =
  ProtectedDashboardMatchsRouteImport.update({
    id: '/matchs',
    path: '/matchs',
    getParentRoute: () => ProtectedDashboardRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/_protected/dashboard': {
      id: '/_protected/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ProtectedDashboardRouteImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/dashboard/matchs': {
      id: '/_protected/dashboard/matchs'
      path: '/matchs'
      fullPath: '/dashboard/matchs'
      preLoaderRoute: typeof ProtectedDashboardMatchsRouteImport
      parentRoute: typeof ProtectedDashboardRouteImport
    }
    '/_protected/dashboard/users': {
      id: '/_protected/dashboard/users'
      path: '/users'
      fullPath: '/dashboard/users'
      preLoaderRoute: typeof ProtectedDashboardUsersRouteImport
      parentRoute: typeof ProtectedDashboardRouteImport
    }
    '/_protected/dashboard/': {
      id: '/_protected/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof ProtectedDashboardIndexImport
      parentRoute: typeof ProtectedDashboardRouteImport
    }
  }
}

// Create and export the route tree

interface ProtectedDashboardRouteRouteChildren {
  ProtectedDashboardMatchsRouteRoute: typeof ProtectedDashboardMatchsRouteRoute
  ProtectedDashboardUsersRouteRoute: typeof ProtectedDashboardUsersRouteRoute
  ProtectedDashboardIndexRoute: typeof ProtectedDashboardIndexRoute
}

const ProtectedDashboardRouteRouteChildren: ProtectedDashboardRouteRouteChildren =
  {
    ProtectedDashboardMatchsRouteRoute: ProtectedDashboardMatchsRouteRoute,
    ProtectedDashboardUsersRouteRoute: ProtectedDashboardUsersRouteRoute,
    ProtectedDashboardIndexRoute: ProtectedDashboardIndexRoute,
  }

const ProtectedDashboardRouteRouteWithChildren =
  ProtectedDashboardRouteRoute._addFileChildren(
    ProtectedDashboardRouteRouteChildren,
  )

interface ProtectedRouteChildren {
  ProtectedDashboardRouteRoute: typeof ProtectedDashboardRouteRouteWithChildren
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedDashboardRouteRoute: ProtectedDashboardRouteRouteWithChildren,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof ProtectedRouteWithChildren
  '/login': typeof LoginRoute
  '/dashboard': typeof ProtectedDashboardRouteRouteWithChildren
  '/dashboard/matchs': typeof ProtectedDashboardMatchsRouteRoute
  '/dashboard/users': typeof ProtectedDashboardUsersRouteRoute
  '/dashboard/': typeof ProtectedDashboardIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof ProtectedRouteWithChildren
  '/login': typeof LoginRoute
  '/dashboard/matchs': typeof ProtectedDashboardMatchsRouteRoute
  '/dashboard/users': typeof ProtectedDashboardUsersRouteRoute
  '/dashboard': typeof ProtectedDashboardIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/login': typeof LoginRoute
  '/_protected/dashboard': typeof ProtectedDashboardRouteRouteWithChildren
  '/_protected/dashboard/matchs': typeof ProtectedDashboardMatchsRouteRoute
  '/_protected/dashboard/users': typeof ProtectedDashboardUsersRouteRoute
  '/_protected/dashboard/': typeof ProtectedDashboardIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/login'
    | '/dashboard'
    | '/dashboard/matchs'
    | '/dashboard/users'
    | '/dashboard/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/login'
    | '/dashboard/matchs'
    | '/dashboard/users'
    | '/dashboard'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/login'
    | '/_protected/dashboard'
    | '/_protected/dashboard/matchs'
    | '/_protected/dashboard/users'
    | '/_protected/dashboard/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  LoginRoute: LoginRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_protected",
        "/login"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_protected": {
      "filePath": "_protected.tsx",
      "children": [
        "/_protected/dashboard"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/_protected/dashboard": {
      "filePath": "_protected/dashboard/route.tsx",
      "parent": "/_protected",
      "children": [
        "/_protected/dashboard/matchs",
        "/_protected/dashboard/users",
        "/_protected/dashboard/"
      ]
    },
    "/_protected/dashboard/matchs": {
      "filePath": "_protected/dashboard/matchs/route.tsx",
      "parent": "/_protected/dashboard"
    },
    "/_protected/dashboard/users": {
      "filePath": "_protected/dashboard/users/route.tsx",
      "parent": "/_protected/dashboard"
    },
    "/_protected/dashboard/": {
      "filePath": "_protected/dashboard/index.tsx",
      "parent": "/_protected/dashboard"
    }
  }
}
ROUTE_MANIFEST_END */
